import { apiGet, apiPatch } from '@/lib/http/client';

import type {
  SalesforceFieldMapping,
  SalesforceFieldMappingsResponse,
} from '../types';

export type UpdateMappingBody = Partial<{
  ahoy_property: string | null;
  sync_direction: string;
  conflict_resolution: string | null;
}>;

export async function getSalesforceFieldMappings(
  orgId: number | string
): Promise<SalesforceFieldMappingsResponse> {
  return apiGet<SalesforceFieldMappingsResponse>(
    `/api/orgs/${orgId}/salesforce/field-mappings/`
  );
}

export async function updateSalesforceFieldMapping(
  orgId: number | string,
  mappingId: number,
  body: UpdateMappingBody
): Promise<SalesforceFieldMapping> {
  return apiPatch<SalesforceFieldMapping>(
    `/api/orgs/${orgId}/salesforce/field-mappings/${mappingId}/`,
    body
  );
}
